import { effect, inject, PLATFORM_ID, signal, Service } from '@angular/core';
import { ThemeEnum } from 'src/app/_api/enums/theme.enum';
import { isPlatformBrowser } from '@angular/common';

@Service()
export class ThemeService {
  readonly theme = signal(localStorage.getItem('theme') ?? ThemeEnum.SYSTEM);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly matchMediaDarkMode?: MediaQueryList;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.matchMediaDarkMode = globalThis.matchMedia('(prefers-color-scheme: dark)');

      effect(() => localStorage.setItem('theme', this.theme()));

      effect(() => {
        const theme = this.theme();
        if ((theme === ThemeEnum.SYSTEM && this.matchMediaDarkMode?.matches) || theme === ThemeEnum.DARK) {
          ThemeService.activateDarkMode();
        } else {
          ThemeService.activateLightMode();
        }
        if (theme === ThemeEnum.SYSTEM) {
          this.matchMediaDarkMode?.addEventListener('change', ThemeService.handleSystemThemeChange, true);
        } else {
          this.matchMediaDarkMode?.removeEventListener('change', ThemeService.handleSystemThemeChange, true);
        }
      });
    }
  }

  private static readonly handleSystemThemeChange = (event: MediaQueryListEvent) =>
    event.matches ? ThemeService.activateDarkMode() : ThemeService.activateLightMode();

  private static readonly activateDarkMode = () => {
    document.documentElement.classList.add('dark');
    document.documentElement.dataset['theme'] = 'dark';
  };

  private static readonly activateLightMode = () => {
    document.documentElement.classList.remove('dark');
    document.documentElement.dataset['theme'] = 'light';
  };
}
